import { render } from "./Header.vue?vue&type=template&id=1f234af1&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=1f234af1&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1f234af1"
/* hot reload */
if (module.hot) {
  script.__hmrId = "1f234af1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f234af1', script)) {
    api.reload('1f234af1', script)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=1f234af1&scoped=true", () => {
    api.rerender('1f234af1', render)
  })

}

script.__file = "src/components/common/Header.vue"

export default script